// /src/pages/private/settings/account/AccountProfileThemeSwatch.jsx

import React, { useMemo } from 'react';
import DonorShootingStar from '../../../../components/tools/memberProfileCard/DonorShootingStar';
import PerkThemeHaloLayer from '../../../../components/tools/memberProfileCard/PerkThemeHaloLayer';
import PerkThemeMediaLayer from '../../../../components/tools/memberProfileCard/PerkThemeMediaLayer';
import PerkThemeOverlayEffects from '../../../../components/tools/memberProfileCard/PerkThemeOverlayEffects';
import PerkThemeUnderlayEffects from '../../../../components/tools/memberProfileCard/PerkThemeUnderlayEffects';
import { resolveProfileThemeEffects, resolveVideoDarken } from '../../../../utils/memberProfileThemeDisplay';

/** Mini live preview of a theme (banner media + overlay FX). */
export default function AccountProfileThemeSwatch({ theme = null }) {
  const effects = useMemo(
    () => resolveProfileThemeEffects(theme || null),
    [theme],
  );

  const mediaUrl = effects.bannerMediaUrl || effects.cardMediaUrl || null;
  const mediaType = effects.bannerMediaUrl
    ? effects.bannerMediaType
    : effects.cardMediaType;
  const mediaDarken = effects.bannerMediaUrl
    ? resolveVideoDarken(
      effects.bannerMediaUrl,
      effects.bannerMediaType,
      effects.effectConfig?.bannerVideoDarken,
    )
    : resolveVideoDarken(
      effects.cardMediaUrl,
      effects.cardMediaType,
      effects.effectConfig?.cardVideoDarken,
    );
  const overlays = effects.overlayEffectKeys;
  const hasHalo = Boolean(effects.effectConfig?.haloColor);
  const hasFx = Boolean(effects.effectKey)
    || Boolean(mediaUrl)
    || overlays.length > 0
    || hasHalo;
  const legacySpace = Boolean(effects.showDonorSpace);

  if (!theme || !hasFx) {
    return (
      <span
        className="account-profile-theme__swatch account-profile-theme__swatch--none"
        aria-hidden
      />
    );
  }

  return (
    <span
      className={[
        'account-profile-theme__swatch',
        'account-profile-theme__swatch--live',
        legacySpace ? 'account-profile-theme__swatch--legacy-space' : '',
        effects.isPremiumEffect ? 'account-profile-theme__swatch--premium' : '',
      ].filter(Boolean).join(' ')}
      aria-hidden
    >
      <PerkThemeHaloLayer effectConfig={effects.effectConfig} />
      {overlays.length ? (
        <PerkThemeUnderlayEffects
          effectKeys={overlays}
          effectConfig={effects.effectConfig}
        />
      ) : null}
      {mediaUrl ? (
        <PerkThemeMediaLayer
          url={mediaUrl}
          mediaType={mediaType}
          darken={mediaDarken}
          className="account-profile-theme__swatch-media"
        />
      ) : null}
      {effects.showNebulaMorph ? (
        <span className="account-profile-theme__swatch-nebula-morph" />
      ) : null}
      {effects.showShootingStars ? <DonorShootingStar /> : null}
      {overlays.length ? (
        <PerkThemeOverlayEffects
          effectKeys={overlays}
          mediaUrl={mediaUrl}
          mediaType={mediaType}
          effectConfig={effects.effectConfig}
        />
      ) : null}
    </span>
  );
}
